import { all, fork, select } from 'redux-saga/effects';

import { SubmitStakePayload } from '../staking/types';
import type { SagaIterator } from '@redux-saga/types';

import { SubmitStakeType } from '../../constants';
import { RecordOfStakeTypeAmountType } from '../../records';
import { selectTotalAmountActive } from '../../selectors/entries';
import { selectSingleAmountEntry, selectSingleBetsInfo } from '../../selectors/stakeTypes/single';
import { EntriesBets } from '../../types/entries';
import { BetsInfo } from '../../types/stakeTypes/singles';
import { parseAmount } from '../../utils/parsing';
import { submitStake } from '../staking';

// ---

export default function* processSingles(entries: EntriesBets): SagaIterator {
  const $amount: RecordOfStakeTypeAmountType = yield select(selectSingleAmountEntry);
  const betsInfo: BetsInfo = yield select(selectSingleBetsInfo);
  const totalAmountActive: boolean = yield select(selectTotalAmountActive);

  const filteredEntries = entries.reduce((calls, entry) => {
    const info = betsInfo.get(entry.entity.id);
    const entryAmount = info?.get('amount');

    if (!entryAmount || !entry.entity.isOpen) {
      console.error('processSingles -> `entryAmount` not found or `entry` closed');
      return calls;
    }

    const value = totalAmountActive
      ? $amount.value
      : entryAmount.value;

    const amount = parseAmount(value);

    if (Number.isNaN(amount)) {
      console.error('processSingles -> `amount` is not a number');
      return calls;
    }

    const payload: SubmitStakePayload = {
      type: SubmitStakeType.SINGLE,
      bets: [{
        id: entry.entity.id,
        matchId: entry.entity.matchId,
        price: entry.price,
      }],
      amount,
    };

    if (!totalAmountActive) {
      if (info?.pledgeStake) {
        payload.pledgeStakeId = info.pledgeStake.stakeId;
      }

      if (info?.freeBet) {
        payload.freeBetId = info.freeBet.id;
      }
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore // TODO: Понятия не имею, как это типизировать, чтобы .push() не ругался
    calls.push(fork(submitStake, payload));

    return calls;
  }, []);

  yield all(filteredEntries);
}
